import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import NoticeBoardtListLayer from "../components/NoticeboardListLayer"; 
 
const NoticeBoardListPage = () => {
  return (
    <>
   
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Noticeboard  </h5><Breadcrumb title="Noticeboard" /></div>
 
        <NoticeBoardtListLayer />
 
 
    </>
  );
};
 
export default NoticeBoardListPage;
 
 